export enum PaymentMethodType {
  BANKGIRO = 'BANKGIRO',
  BBAN = 'BBAN',
  IBAN = 'IBAN',
  OTHER = 'OTHER',
  PAYPAL = 'PAYPAL',
  PLUSGIRO = 'PLUSGIRO',
  SWISH = 'SWISH',
}
